<template>
    <div class="portlet light bordered" v-if="canShow">
        <div class="portlet-title">
            <div class="caption">
                <i class="icon-equalizer font-red-sunglo"></i>
                <span class="caption-subject font-red-sunglo bold uppercase">{{ trans('note.note') }}</span>
            </div>
        </div>
        <div class="portlet-body form">
            <div class="timeline">
                <div class="timeline-item">
                    <div class="timeline-badge">
                        <div class="timeline-icon">
                            <i class="icon-note"></i>
                        </div>
                    </div>
                    <div class="timeline-body">
                        <div class="timeline-body-arrow"> </div>
                        <div class="timeline-body-head">
                            <div class="timeline-body-head-caption">
                                <a href="#!" class="timeline-body-title font-blue-madison">{{ trans('note.add') }}</a>
                                <span class="timeline-body-time font-grey-cascade">{{ date }}</span>
                            </div>
                        </div>
                        <div class="timeline-body-content">
                            <textarea v-model="note" class="form-control" rows="3" v-bind:placeholder="trans('note.default_note')"></textarea>
                            <br/>
                            <div class="col-sm-12 text-right">
                                <button class="btn btn-success" @click="addNote">{{ trans('note.save') }}</button>
                            </div>
                        </div>
                    </div>
                </div>

                <template v-for="(item, index) in list">
                        <div class="timeline-item list-complete-animation" v-bind:data-note-id="item.id">
                            <div class="timeline-badge">
                                <div v-bind:class="{ 'timeline-icon bg-yellow-gold': item.editMode, 'timeline-icon': !item.editMode}">
                                    <i class="icon-bubbles"></i>
                                </div>
                            </div>
                            <div class="timeline-body">
                                <div class="timeline-body-arrow"> </div>
                                <div class="timeline-body-head">
                                    <div class="timeline-body-head-caption">
                                        <a href="#!" class="timeline-body-title font-blue-madison">{{ item.userName ? item.userName : '' }}</a>
                                        <span class="timeline-body-time font-grey-cascade">{{ formatDate(item.createdAt) }}</span>
                                    </div>
                                    <div class="timeline-body-head-actions" v-if="showActions(item.userId)">
                                        <div class="btn-group">
                                            <button v-if="canEdit" class="btn btn-circle btn-sm" type="button" @click="editMode(index)">
                                                <i v-bind:class="{ 'fa fa-check': item.editMode, 'fa fa-pencil': !item.editMode}"></i>
                                            </button>
                                            <button class="btn btn-circle btn-sm" type="button" @click="remove(index)">
                                                <i v-bind:class="{ 'fa fa-times': item.editMode, 'fa fa-trash': !item.editMode}"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div class="timeline-body-content">
                                    <textarea v-if="item.editMode" v-model="item.note"  class="form-control" rows="3"></textarea>
                                    <span v-else class="font-grey-cascade"> {{ item.note }}</span>
                                </div>
                            </div>
                        </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue'
    import moment from 'moment';
    import toastr from '../../../../../../public/build/js/toastr'
    import bootbox from 'bootbox';

    export default {
        props: {
            note_key: {
                type: String,
                default: null
            },
            pk : {
                type: String,
                default: 0
            },
        },
        data: function () {
            return {
                canShow: false,
                note: '',
                list: [],
                date: moment().locale('pl').format('LLLL'),
                oldValues: [],
                canEdit: true,
            };
        },
        watch : {

        },
        mounted: function () {
            this.checkConfiguration();
        },
        methods: {
            checkConfiguration(){
                let url = Routing.generate('check_note_config', {noteKey: this.note_key});

                Vue.http.get(url).then(response => {
                    this.canShow = response.data.allow;
                    this.canEdit = response.data.edit;
                    this.getNotes();
                });
            },
            getNotes(){
                if(!this.canShow){
                    return;
                }

                let url = Routing.generate('get_note_list', {identifier: this.pk, noteKey: this.note_key});

                Vue.http.get(url).then(response => {
                    this.list = response.data.map((list) => {
                        list.editMode = false;
                        return list;
                    });
                }, response => {
                    this.handleAjaxError(response);
                });
            },
            formatDate(date){
                return moment(date).locale('pl').format('LLLL');
            },
            addNote(){
                if(this.note.length < 1){
                    toastr.warning(Translator.trans('note.cannot_be_empty'));
                    return;
                }

                let url = Routing.generate('create_note', {identifier: this.pk, noteKey: this.note_key});

                Array.prototype.unshift.apply(this.list, [{
                    createdAt: new Date(),
                    userName: $('.username').first().text(),
                    editMode: false,
                    note: this.note
                }]);

                Vue.http.post(url, {note: { note: this.note}}).then(response => {
                    this.getNotes();
                }, response => {
                    this.note = this.list[0].note;
                    this.list.shift();
                    toastr.error(Translator.trans('note.cannot_save'));

                });

                this.note = '';

            },
            editMode(index){
                this.list[index].editMode = !this.list[index].editMode;

                if(this.list[index].editMode){
                    this.oldValues[this.list[index].id] = Object.assign({}, this.list[index]);
                } else {
                    this.saveEdit(this.list[index]);
                }
            },
            remove(index){
                if(this.list[index].editMode){
                    this.list[index].note = this.oldValues[this.list[index].id].note;
                    this.list[index].editMode = false;
                } else {
                    this.delete(this.list[index], index);
                }
            },
            saveEdit(item){
                let url = Routing.generate('update_note', {id: item.id, noteKey: this.note_key});

                Vue.http.post(url, {note: { note: item.note}}).then(response => {
                }, response => {
                    toastr.error(Translator.trans('note.cannot_save'));

                });
            },
            delete(item, index){
                let _self = this;
                let obj = $('[data-note-id="' + item.id + '"] .timeline-icon');
                obj.addClass('bg-red');
                bootbox.confirm({
                    title: Translator.trans('note.confirm'),
                    message: ' ',
                    buttons: {
                        cancel: {
                            label: '<i class="fa fa-times"></i> ' + Translator.trans('note.back')
                        },
                        confirm: {
                            label: '<i class="fa fa-check"></i> ' + Translator.trans('note.remove')
                        }
                    },
                    callback: function (result) {
                        if(result === true){
                            let url = Routing.generate('delete_note', {id: item.id});
                            Vue.http.delete(url).then(response => {
                            }, response => {
                                toastr.error(Translator.trans('note.cannot_remove'));
                            });

                            _self.list.splice(index, 1);
                        } else {
                            obj.removeClass('bg-red');
                        }
                    }
                });
            },
            showActions(userId){
                return userId == window.appValues.userId;
            },
            trans(id){
                return Translator.trans(id);
            }
        },

    }
</script>
